import React, { memo } from 'react'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import EditCanvas from './Components/EditCanvas/EditCanvas'
import EmptyState from './Components/EmptyState/EmptyState'

function EditTab() {
  const editImage = useThreeDStudioStore(state => state.ui.editImage)

  if (!editImage) {
    return <EmptyState />
  }

  // Key on the loaded image so loading a different image starts a fresh session,
  // while switching tabs (editImage unchanged) preserves the current one.
  return <EditCanvas key={editImage.id} />
}

export default memo(EditTab)
